import { handleActions } from 'redux-actions'
import Immutable from 'immutable'

import * as actions from '../actions/newTasks';

const initialState = Immutable.fromJS({
  data: [],
  loading: false,
  loaded: false
})

export default handleActions({
  // 积分查询
  [actions.getnewTasksSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getnewTasksFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
}, initialState)



// WEBPACK FOOTER //
// ./reducers/newTasks.js